export interface DestMasterRequest {
  name: string
  description?: string | null
  sort_num?: number | null
}

export interface DestMasterResponse {
  id: number
  name: string
  description: string | null
  sort_num: number | null
  entry_dt: string
  update_dt: string
}

export interface SubDestMasterRequest {
  name: string
  description?: string | null
  sort_num?: number | null
  dest_id: number
}

export interface SubDestMasterResponse {
  id: number
  name: string
  description: string | null
  sort_num: number | null
  dest_id: number
  dest_name?: string | null
  entry_dt: string
  update_dt: string
}

export interface MagoMasterRequest {
  dest_id: number
  sub_dest_id?: number | null
  lot_id?: string | null
  group_id?: string | null
  product_id?: string | null
  mago_id: string
  sim_id?: string | null
  lte_type?: string | null
  lte_plan?: string | null
  lte_apn?: string | null
  status?: number
}

export interface MagoMasterResponse {
  id: number
  dest_id: number
  sub_dest_id: number | null
  lot_id: string | null
  group_id: string | null
  product_id: string | null
  mago_id: string
  sim_id: string | null
  lte_type: string | null
  lte_plan: string | null
  lte_apn: string | null
  status: number
  entry_dt: string
  update_dt: string
  dest_name: string | null
  sub_dest_name: string | null
}

export const DEVICE_STATUS_MAP = {
  0: { label: '未使用', color: 'secondary' },
  1: { label: '使用中', color: 'success' },
  2: { label: '停止', color: 'warning' },
  9: { label: '故障', color: 'danger' },
} as const

export type DeviceStatus = keyof typeof DEVICE_STATUS_MAP

export interface FormErrors {
  [key: string]: string
}
